// extracted by mini-css-extract-plugin
export default {"error":"Timer_error__hGrSz"};